<template>
  <el-select
    ref="select"
    v-model="value"
    :class="{
      'has-selection': value !== '',
    }"
    :popper-class="popperClass"
    :placeholder="label"
    :data-label="label"
    :clearable="true"
    :filterable="filterable"
    @change="onChange">
    <!-- Mobile return button -->
    <slot name="prefix">
      <div class="container m:hidden">
        <button
          type="button"
          class="w-full type-label flex items-center py-6"
          @click="closeDropdown()">
          <svg width="7.8px" height="12.8px" viewBox="0 0 7.8 12.8">
            <polygon points="6.4,12.8 0,6.4 6.4,0 7.8,1.4 2.8,6.4 7.8,11.3" />
          </svg>
          <span class="inline-block ml-4">
            {{ label }}
          </span>
        </button>
      </div>
    </slot>

    <!-- Dropdown list -->
    <div
      v-for="item in options"
      :key="item.label">
      <template v-if="item.type === 'optgroup'">
        <el-option-group :label="item.label">
          <el-option
            v-for="opt in item.options"
            :key="opt.value"
            :label="opt.label"
            :value="opt.value" />
        </el-option-group>
      </template>

      <template v-if="item.type === 'option' ">
        <el-option
          :label="item.label"
          :value="item.value" />
      </template>
    </div>
  </el-select>
</template>

<script>
  export default {
    props: {
      /**
       * JSON to create the <option> list
       */
      options: {
        type: Array,
        required: true,
      },
      /**
       * A URL parameter key to sync the value with.
       * @type {String}
       */
      urlParam: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        required: true,
      },
      popperClass: {
        type: String,
        default: '',
      },
      /**
       * Wether we can filter the values or not.
       * @link https://element.eleme.io/#/en-US/component/select#option-filtering
       * @type {Boolean}
       */
      filterable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        value: '',
      };
    },
    mounted() {
      if (this.urlParam) {
        this.updateValueFromURLParam();
      }

      // Reset local selected value
      // Emit by onResetClick in Filters.js
      document.body.addEventListener('resetFilters', this.resetFilters);
    },
    destroyed() {
      document.body.removeEventListener('resetFilters', this.resetFilters);
    },
    methods: {
      resetFilters() {
        this.value = '';
      },
      onChange(value) {
        this.$emit('update', value);
      },
      closeDropdown() {
        this.$refs.select.blur();
      },
      updateValueFromURLParam() {
        const params = new URLSearchParams(window.location.search);

        if (!params.has(this.urlParam)) {
          return;
        }

        this.value = params.get(this.urlParam);
      },
    },
  };
</script>
